import sthetoscopeBgImage from "../assets/sthetoscope.jpg";

const styles = theme => ({
  volunteerForm: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "flex-start",
    width: "100vw",
    backgroundImage: `url(${sthetoscopeBgImage})`,
    backgroundSize: "cover"
  },
  appHeader: {
    position: "absolute"
  },
  formTitle: {
    marginBottom: 15,
    fontFamily: "Roboto, sans-serif",
    fontSize: "1.8rem"
  },
  formContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent:"flex-start",
    paddingTop: 25,
    paddingLeft: 10,
    paddingRight: 10,
    paddingBottom: 25,
    height: "calc(100vh - 200px)"
  },
  listItemText:{
    fontSize:'18px'
  },
  sendButton: {
    margin:30
  },
  calendar: {
    flex: 1,
    width: "100%",
    maxHeight: "calc(100% - 100px)"
  }
});

export default styles;
